import { useNavigate } from 'react-router-dom'

/**
 * 앱 내부 이동 이력이 있으면 뒤로가기, 없으면 fallback 경로로 이동.
 *
 * 구글 검색 등 외부 유입으로 상세 페이지에 바로 들어온 경우
 * 뒤로가기 시 외부 페이지로 나가버리는 문제를 방지한다.
 *
 * React Router v6은 `window.history.state.idx`로 스택 내 위치를 추적한다.
 * idx === 0 이면 앱 기준 첫 진입(= 외부/직접 URL 접속)을 의미한다.
 *
 * @param fallback 외부 유입 시 이동할 경로 (기본: /facilities)
 */
export function useSmartBack(fallback: string = '/facilities') {
  const navigate = useNavigate()

  return () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0
    if (idx > 0) {
      navigate(-1)
    } else {
      navigate(fallback, { replace: true })
    }
  }
}
